import React, { useEffect, useState,Suspense,lazy } from "react";
import { Button } from "../../../../index";
import styles from "./RaportForm.module.scss";
import { SignRaportFile, createRaport } from "service/StatementsService";
import { useDispatch, useSelector } from "react-redux";
import { postStatement } from "store/slices/StatementsSlice";
import Notification from "utils/Notifications";
import { TextareaAutosize } from "@material-ui/core";

import Dropdown from "../../../../Dropdown/Dropdown";
import userInfo from "utils/userInfo";
import { getMyMembers } from "service/CollectiveService";
import { setMyMembers } from "store/slices/CollectiveSlice";
import { ScaleLoader } from "react-spinners";
import { AddWaterMark } from "hooks/PdfWaterMark/AddWaterMark";
const OrderSigner = lazy(() => import('components/Forms/OrderForm/components/OrderSigner'))


function RaportForm({ setRender , setState}) {
  //UseState
  const user = userInfo()
  const request_type = [
    { id: 0, label: 'Бизнес план' },
    { id: 1, label: 'Благодарственное письмо' },
    { id: 2, label: 'Деловое письмо' },
    { id: 3, label: 'Договор' },
    { id: 4, label: 'Жалоба' },
    { id: 5, label: 'Запрос на информацию' },
    { id: 6, label: 'Заявление' },
    { id: 7, label: 'Обращение' },
    { id: 8, label: 'Паспорт проекта' },
    { id: 9, label: 'Письмо' },
    { id: 10, label: 'Приказ' },
    { id: 11, label: 'Приглашение' },
    { id: 12, label: 'Рапорт' },
    { id: 13, label: 'Уведомление' },
    
  ]
  const [data] = useState()
  const [signer ,setSigner] = useState('')

 
  const [id, setId] = useState('');
  const [type_doc, setType_doc] = useState("");
  const [type, setType] = useState("");
  const [text, setText] = useState("");

  const [file, setFile] = useState([]);
  const [file1, setFile1] = useState(null);
  
  const [loader, setLoader] = useState(false);
  const [chooseFile,setChooseFile] = useState(false)
  const [chooseText,setChooseText] = useState(false)
  //Notification
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  //Dispatch
  const dispatch = useDispatch();
  //Const & Let


     const getData = async () => {
      try {
        let response = await getMyMembers('task',data);
        
        dispatch(
          setMyMembers({
            members: response.data,
          })
        );
    
      } catch (error) {
        
      }
      };
    
      useEffect(() => {
      getData();

      }, []);
    

    const myTeam = useSelector((state) => state.collective.members);
    const confirmedEmployees = myTeam ? [myTeam.confirmed] : []
    const dataRector = [confirmedEmployees.flat().filter((item) => item.flag)]
    const handleFileUpload = (e) => {
      const file = e.target.files[0];
      if (file.type === 'application/pdf') {
        setFile1(file);
      } else {
       
        setNotify({
          isOpen: true,
          message: " Выберите файл в формате PDF",
          type: "warning",     sound: 'warning'
        });
      }
    };
    
    
  const onFileChange = (event) => {
    setFile(event.target.files);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData();

    if (type === "") {
      setNotify({
        isOpen: true,
        message: " Вы не указали тему документа",
        type: "warning",     sound: 'warning'
      });
     
    }    
  
    else if (file1 === null && text === ''){
      setNotify({
        isOpen: true,
        message: " Вы не прикрепили основной файл либо не ввели содержание",
        type: "warning",     sound: 'warning'
      });
      
    }
    else if (type_doc === ''){
      setNotify({
        isOpen: true,
        message: " Вы не указали тип документа",
        type: "warning",     sound: 'warning'
      });
      
    }
    else if (signer === user.userId) {
      setNotify({
        isOpen: true,
        message: " Адрессат является пользователем!",
        type: "warning",     sound: 'warning'
      });
    } 
    else if (file1 !== null && text !== '') {
      setNotify({
        isOpen: true,
        message: "Введите содержание либо файл",
        type: "warning",     sound: 'warning'
      });
    } 
    else
    try {
  
  
  setLoader(true);
  const formData = new FormData();
  formData.append('addressee',signer);
  formData.append('type', type);
  formData.append('type_doc', type_doc);
  formData.append('text', text);
      if (file1) {
         formData.append('file', file1);
      }
 
  
  for (let i = 0; i < file.length; i++) {
    formData.append('files', file[i]);
  }
  
  
  
  
  
  let response = await createRaport(formData);

  dispatch(
    postStatement({
      addressee:signer,
         
            type:type,
            type_doc,
            text: text,
            file: file ? file.name : null,
          })
          );
          const modifedFile = await AddWaterMark({
            name: user.lastName ? `${user.surName}.${user.firstName?.split('')[0]}.${user.lastName?.split('')[0]}` : `${user.surName}.${user.firstName?.split('')[0]}`,

            type : "Подписал",
            count_turn : 1,
            file: response.data.file,
          });
          let SignStatementFile = {
            addressee: response.data.addressee,
            status: 'В режиме ожидания',
            file: modifedFile,
          };
       
          let response2 = await SignRaportFile(response.data.id, SignStatementFile);
        setNotify({
          isOpen: true,
          message: "Рапорт успешно отправлен",
           type: "success", sound : "success"
        });
        setState(({ isPaneOpen: false } ))
        setRender(true)

      } catch (error) {
        

        setNotify({
          isOpen: true,
          message: "Ошибка",
          type: "error",
        });
      }finally {
        setLoader(false);
      }

  };



  return (
    <div>
         <div className={styles.signer} style={{width:'100%'}}>
       <Dropdown setId={setId} setType={setType_doc} title = {'Тип документа'} data = {request_type ?? []}/>
       </div>
      <div className={styles.signer}>
      <Suspense fallback={<p>Loading...</p>}>

<OrderSigner text = {"Кому:"} dataSigners = {dataRector[0]} setSigner = {setSigner}/>
</Suspense>
       </div>
    
       <TextareaAutosize
        id="type"
        name="type"
        className={styles.type_input}
        value={type}
        onChange={(e) => setType(e.target.value)}
        placeholder="Тема:"
        maxLength={255}
        
      />
        <div style={{display: 'flex', flexDirection: 'column' ,gap : '30px'}}>
      {
        chooseFile || chooseText ? null :  ( <div style={{display: 'flex', justifyContent: 'space-between'}}>

       <button onClick={() => setChooseFile(true)} style={{fontWeight: '400',padding: '3px 7px', borderRadius: '3px',border: 'none',cursor: 'pointer'}}><span style={{color: 'red', fontSize: '18px', fontWeight: '400'}}>*</span>Выбрать основной документ</button>
       <p>либо</p>
       <button  onClick={() => setChooseText(true)} style={{fontWeight: '400',padding: '3px 7px', borderRadius: '3px',border: 'none',cursor: 'pointer'}}><span style={{color: 'red', fontSize: '18px', fontWeight: '400'}}>*</span>Ввести содержимое документа</button>
      </div>) 
      }
     

      {chooseFile === true ? (<div className={styles.add_statement_file} style={{margin: '10px 0px'}}>
       <h4 style={{fontWeight: '400'}}><span style={{color: 'red', fontSize: '18px', fontWeight: '400'}}>*</span>Прикрепите основной документ</h4>
       <input type="file" accept=".pdf" onChange={(e) => handleFileUpload(e)} />

      
      </div>) : null}
      {chooseText === true ? ( <TextareaAutosize
        id="text"
        name="text"
        type="textarea"
        className={styles.discription_input}
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Содержание:"
       
      />
      ) : null}
      

      <div style={{marginTop: '10px'}} className={styles.add_statement_file}>
       <h4 style={{fontWeight: '400'}}>Прикрепите дополнительные документы</h4>

      <input type="file" multiple  onChange={onFileChange} />
        <span>Прикрепление файла</span>
      </div>
      
      <div className={styles.statement_footer}>
      {loader ? (
        <ScaleLoader color="black" size={30} />
      ) : (
        <Button className={styles.btn1} onClick={handleSubmit}>
          Отправить
        </Button>
      )}
      
      </div>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </div>
    
  );
}

export default RaportForm;
